import { SALE_API_URL } from "../../../constants";
import { apiSlice } from "../../../services";
import {
    ICreateAmazeLinkReq,
    ICreateAmazeLinkRes,
    ICreateApiKeyReq,
    ICreateApiKeyRes,
    IGetAmazeLinkReq,
    IGetAmazeLinkRes,
    IGetApiKeysReq,
    IGetApiKeysRes,
    IGetOrgInfoReq,
    IGetOrgInfoRes,
} from "../types/interfaces";

export const orgApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // Get organization info
        getOrgInfo: builder.query<IGetOrgInfoRes, IGetOrgInfoReq>({
            query: (params) => ({
                url: `${SALE_API_URL}/orgs/${params.org_id}`,
                method: "GET",
            }),
            providesTags: ["SalesItems"],
        }),
        // Get Amaze Link info
        getAmazeLink: builder.query<IGetAmazeLinkRes, IGetAmazeLinkReq>({
            query: (params) => ({
                url: `${SALE_API_URL}/orgs/${params.org_id}/amaze_link`,
                method: "GET",
            }),
            providesTags: ["AmazeLink"],
        }),
        // Create Amaze Link
        createAmazeLink: builder.mutation<ICreateAmazeLinkRes, ICreateAmazeLinkReq>({
            query: (params) => ({
                url: `${SALE_API_URL}/orgs/${params.org_id}/amaze_link`,
                method: "POST",
                body: params.body,
            }),
            invalidatesTags: ["AmazeLink"],
        }),
        // Get API Keys
        getApiKeys: builder.query<IGetApiKeysRes, IGetApiKeysReq>({
            query: (params) => ({
                url: `${SALE_API_URL}/orgs/${params.org_id}/api_keys`,
                method: "GET",
                params: {
                    page: params.page || 1,
                    limit: params.limit || 12,
                },
            }),
            providesTags: ["ApiKeys"],
        }),
        // Create API Key for Organization (Sales)
        createOrgApiKey: builder.mutation<ICreateApiKeyRes, ICreateApiKeyReq>({
            query: (params) => ({
                url: `${SALE_API_URL}/orgs/${params.org_id}/api_keys`,
                method: "POST",
                body: params.body,
            }),
            invalidatesTags: ["ApiKeys"],
        }),
    }),
});

export const {
    useGetOrgInfoQuery,
    useGetAmazeLinkQuery,
    useCreateAmazeLinkMutation,
    useGetApiKeysQuery,
    useCreateOrgApiKeyMutation,
} = orgApiSlice;
